import cn from 'classnames';

import { IConDefaultType } from '../../types';

export enum DateIconVariant {
  DEFAULT = 'default',
}
export interface IDateIconProps extends IConDefaultType {
  variant?: DateIconVariant;
}

export default function DateIcon({
  color,
  className,
  size = 20,
  rotate,
  flip,
  variant = DateIconVariant.DEFAULT,
}: IDateIconProps) {
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === DateIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
          <path
            d="M3.125 2.5V11.875C3.125 12.3723 3.32254 12.8492 3.67417 13.2008C4.02581 13.5525 4.50272 13.75 5 13.75H6.875M3.125 2.5H1.875M3.125 2.5H16.875M6.875 13.75H13.125M6.875 13.75L6.04167 16.25M16.875 2.5H18.125M16.875 2.5V11.875C16.875 12.3723 16.6775 12.8492 16.3258 13.2008C15.9742 13.5525 15.4973 13.75 15 13.75H13.125M13.125 13.75L13.9583 16.25M6.04167 16.25H13.9583M6.04167 16.25L5.625 17.5M13.9583 16.25L14.375 17.5M7.5 9.375V10.625M10 7.5V10.625M12.5 5.625V10.625"
            stroke="black"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </i>
  );
}
